import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import { productReducer } from "./reducers/productReducer";

const rootReducer = combineReducers({
  products: productReducer,
});

const middleware = [thunk];

// ✅ Use browser Redux DevTools if available, else fallback
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(...middleware))
);

export default store;
